
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import SearchFilters from './components/SearchFilters';
import AssetGrid from './components/AssetGrid';
import IncubatorSection from './components/IncubatorSection';
import { updateSEO, generateOrganizationSchema, generateWebsiteSchema, generateServiceSchema } from '../../utils/seo';

export default function Home() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || window.location.origin;
    
    const seoData = {
      title: 'AIExchange - Premier AI Business Marketplace & Incubator',
      description: 'Discover, acquire, or build the next generation of A.I. companies. Explore verified A.I. businesses, agencies, and systems for sale or partner through our incubator.',
      keywords: 'AI business marketplace, AI acquisition, AI incubator, artificial intelligence, SaaS, automation, AI agency, business for sale',
      ogTitle: 'AIExchange - Premier AI Business Marketplace & Incubator',
      ogDescription: 'Discover, acquire, or build the next generation of A.I. companies. Explore verified A.I. businesses, agencies, and systems for sale or partner through our incubator.',
      ogImage: 'https://public.readdy.ai/ai/img_res/13f6679d1ed0d3548748217eb5bfa894.jpg',
      twitterCard: 'summary_large_image',
      canonicalUrl: siteUrl,
      structuredData: [
        generateOrganizationSchema(),
        generateWebsiteSchema(),
        generateServiceSchema()
      ]
    };

    updateSEO(seoData);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      <main>
        <HeroSection />
        <SearchFilters />
        <AssetGrid />
        <IncubatorSection />
      </main>
      <Footer />
    </div>
  );
}
